import { memo, useEffect } from 'react';
import 'prop-types';
import { AccessibilityUtilities, Glyphicon, Badge } from 'reaxl';
import { sendImpressions } from 'reaxl-analytics';
import { myWalletKbbTradeInIndicator } from 'reaxl-analytics-handlers';
import _isEqual from 'lodash/isEqual';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
const {
  withKeyboardAccessibility
} = AccessibilityUtilities;

/**
 *  Renders Wallet badge in header components, and triggers Wallet open when clicked
 */
const WalletHeaderBadge = /*#__PURE__*/memo(_ref => {
  let {
    onWalletTrigger = () => {},
    hasNewTradeIn = false,
    numCreditAppDeals = 0,
    dealNotifications = {},
    dealReminderOn = false
  } = _ref;
  const wrapperProps = {
    className: 'display-flex link-unstyled',
    role: 'button',
    onClick: onWalletTrigger,
    onKeyDown: withKeyboardAccessibility(onWalletTrigger),
    key: 'headerBadgeWalletIcon',
    'aria-label': 'My Wallet',
    'data-cmp': 'wallet-badge',
    tabIndex: 0
  };
  useEffect(() => {
    if (hasNewTradeIn) {
      sendImpressions({
        name: myWalletKbbTradeInIndicator
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasNewTradeIn]);
  const hasDealNotifications = dealNotifications && dealNotifications.total > 0 || dealReminderOn;
  const hasNotifications = hasNewTradeIn || numCreditAppDeals > 0 || hasDealNotifications;
  const dealReminderNotification = dealReminderOn ? 1 : 0;
  const totalNotifications = (hasNewTradeIn ? numCreditAppDeals + 1 : numCreditAppDeals) + (dealNotifications.total || 0) + dealReminderNotification;
  return /*#__PURE__*/jsx("span", {
    ...wrapperProps,
    children: /*#__PURE__*/jsxs("span", {
      className: "user-icon",
      children: [/*#__PURE__*/jsx(Glyphicon, {
        className: "text-size-500",
        glyph: "wallet"
      }), hasNotifications && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Badge, {
          className: "text-size-200",
          children: totalNotifications
        }), "\xA0"]
      })]
    })
  });
}, (prevProps, nextProps) => _isEqual(prevProps, nextProps));
export { WalletHeaderBadge as default };
